import React from 'react'
import Box from '@material-ui/core/Box'
import truncate from 'lodash/truncate'

import { humanizeString } from '@utils/stringMinipulation'
import { R } from '@utils/currency'
import { CueCard, CueCardItem, CueCardTitle } from '../CueCard'
import { CardHeading, CardContent } from '../../components/layout/Card'
import { Tooltip } from '@UILibrary/Tooltip'

export const RiskProductCard = ({ riskProduct, Footer, highlighted }) => {
  return (
    <CueCard
      highlighted={highlighted}
    >
      <RiskProductCardHeading riskProduct={riskProduct} />
      <CardContent>
        <RiskProductName riskProduct={riskProduct} />
        <RiskProductDetails riskProduct={riskProduct} />
      </CardContent>
      <Footer />
    </CueCard>
  )
}

const RiskProductDetails = ({ riskProduct }) => {
  return (
    <>
      <CueCardItem
        name={`Policy Value`}
        value={R(riskProduct.value).format()}
      />
      <CueCardItem
        name={`Monthly contributions`}
        value={R(riskProduct.monthly_contribution).format()}
      />
      {riskProduct.contract_number && (
        <CueCardItem
          name={`Contract number`}
          value={riskProduct.contract_number}
        />
      )}
      {riskProduct.owners?.length > 0 && (
        <CueCardItem
          name={`Owner(s)`}
          value={riskProduct.owners.join(', ')}
        />
      )}
      {riskProduct.payers?.length > 0 && (
        <CueCardItem
          name={`Payer(s)`}
          value={riskProduct.payers.join(', ')}
        />
      )}
      {riskProduct.beneficiaries?.length > 0 && (
        <CueCardItem
          name={`Beneficiaries`}
          value={riskProduct.beneficiaries.join(', ')}
        />
      )}
    </>
  )
}

const RiskProductCardHeading = ({ riskProduct }) =>
  <CardHeading>
    <Box
      display='flex'
      justifyContent='space-between'
      alignItems='center'
    >
      <h5>{humanizeString(riskProduct.product_type)}</h5>
    </Box>
  </CardHeading>

const TRUNCATE_LENGTH = 18

const RiskProductName = ({ riskProduct }) => {
  const isTruncated = (riskProduct.name?.length ?? 0) > TRUNCATE_LENGTH
  const displayName = truncate(riskProduct.name, { length: TRUNCATE_LENGTH })

  return (
    <CueCardTitle>
      <Tooltip label={riskProduct.name} hidden={!isTruncated}>
        <span title={riskProduct.name}>{displayName}</span>
      </Tooltip>
    </CueCardTitle>
  )
}
